<template>
  <span :class="['mb-hero', {'mb-hero--sm': small}]" :title="hero ? hero.name : 'Герой не выбран'">
    <img v-if="hero && hero.avatar && !broken" class="mb-hero__img" :src="hero.avatar" alt="" @error="broken = true">
    <span v-else class="mb-hero__ph">{{ initials }}</span>
    <span v-if="!iconOnly" class="mb-ellipsis">{{ hero ? hero.name : '—' }}</span>
  </span>
</template>

<script>
// Герой из справочника или заглушка: нет в справочнике → «#id», не выбран → «?»
export default {
  name: 'MbHero',
  props: {
    hero: {type: Object, default: null},
    small: {type: Boolean, default: false},
    iconOnly: {type: Boolean, default: false},
  },
  data() {
    return {broken: false}
  },
  computed: {
    initials() {
      if (!this.hero) return '?'
      if (!this.hero.known) return '#'
      return this.hero.name.split(/[\s-]+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase()
    },
  },
  watch: {
    'hero.avatar'() {
      this.broken = false
    },
  },
}
</script>
